import { useCallback } from 'react'
import { ROUTES } from '@constants/index'
import { useEnvironment } from './useEnvironment'
import { getLocalBasePathSearch, setLocalLastPath } from '@utils/navigationUtil'

type UsePathBuilderResult = (relativePath: string | null, stripLocale?: boolean) => string

export const usePathBuilder = (): UsePathBuilderResult => {
  const { basePath } = useEnvironment()

  return useCallback(
    (relativePath: string | null, stripLocale?: boolean): string => {
      let path = ''
      const dbPath = basePath.endsWith('/') ? ROUTES.BASE_NO_SLASH : ROUTES.BASE

      if (relativePath === ROUTES.BASE) {
        path = `${basePath}${dbPath}`
      } else {
        path = `${stripLocale ? basePathNoLocale(basePath) : basePath}${dbPath}/${relativePath}`
      }

      // last path (w/o search) used to check against URL when page is reloaded while drawer is open
      setLocalLastPath(path)

      // retain search parameters
      return `${path}${getLocalBasePathSearch()}`
    },
    [basePath]
  )
}

const basePathNoLocale = (basePath: string): string => {
  return basePath
    .split('/')
    .filter(p => p)
    .slice(1)
    .join('/')
}
